@if (loadingAuthors() || loadingOwners() || loadingResourceTags()) {
  <div class="tt-guideline-filter-popover_spinner">
    <tt-spinner />
  </div>
} @else {
  @if (authors().length > 0) {
    <tt-guidelines-filter-popover-user-selector
      [idPrefix]="'author'"
      [selectedUsers]="filter().authors"
      [title]="'GuidelinesFilterPopover.Author'"
      [users]="authors()"
      (selectedUsersChanged)="handleAuthorSelected($event)" />
  }

  @if (owners().length > 0) {
    <tt-guidelines-filter-popover-user-selector
      [hasSpaceInBetween]="true"
      [idPrefix]="'owner'"
      [selectedUsers]="filter().owners"
      [title]="'GuidelinesFilterPopover.Owner'"
      [users]="owners()"
      (selectedUsersChanged)="handleOwnerSelected($event)" />
  }

  @if (resourceTags().length > 0) {
    <h5 class="tt-guideline-filter-popover_resource-tags-section-title">
      {{ 'GuidelinesFilterPopover.ResourceTags' | transloco }}
    </h5>
    <span class="tt-guideline-filter-popover_resource-tags-search" ttInput>
      <mat-icon ttInputPrefix [icon]="'search'" [iconSize]="16" />
      <input
        data-testid="guideline-filter_resource-tags-search"
        placeholder="{{ 'ResourceTag.SearchPlaceholder' | transloco }}"
        [ngModel]="resourceTagSearchTerm()"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="resourceTagSearchTerm.set($event)" />
    </span>
    <ul class="tt-guideline-filter-popover_resource-tags-list">
      @for (tag of filteredResourceTags(); track tag.id) {
        <li class="tt-guideline-filter-popover_resource-tags-list-item">
          <common-checkbox
            class="tt-guideline-filter-popover_resource-tags-list-item-checkbox"
            [checked]="isResourceTagSelected(tag.id)"
            (checkedChange)="handleResourceTagSelected(tag.id, $event)" />
          <tt-resource-tag-chip [customBackgroundColor]="tag.backgroundColor" [customColor]="tag.color">
            {{ tag.label }}
          </tt-resource-tag-chip>
        </li>
      }
    </ul>
  }

  @if (true) {
    <h5 class="tt-guideline-filter-popover_expiry-section-title">
      {{ 'GuidelinesFilterPopover.RevisionDate' | transloco }}
    </h5>
    <div class="tt-guideline-filter-popover_expiry-section">
      <common-checkbox
        class="tt-guideline-filter-popover_expiry-section-soon-to-expire"
        [checked]="filter().showSoonToExpire"
        (checkedChange)="handleSoonToExpireSelected($event)">
        {{ 'GuidelinesFilterPopover.SoonToExpire' | transloco }}
      </common-checkbox>
      <common-checkbox
        class="tt-guideline-filter-popover_expiry-section-expired"
        [checked]="filter().showExpired"
        (checkedChange)="handleExpiredSelected($event)">
        {{ 'GuidelinesFilterPopover.Expired' | transloco }}
      </common-checkbox>
    </div>
  }
}
